import { getSettingValueWithoutAssignment } from "@faire/help-center-utils/settings/getSetting";
import { HELP_CENTER_TICKET_PETE_EVENTS_FROM_BE_241015 } from "@faire/web-api/indigofair/settings/HELP_CENTER_TICKET_PETE_EVENTS_FROM_BE_241015";
export function getSettingHelpCenterTicketPeteEventsFromBE() {
  return getSettingValueWithoutAssignment(HELP_CENTER_TICKET_PETE_EVENTS_FROM_BE_241015, false);
}